/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import * as React from "react";

export interface SideNavItemConfig {
  key: string;
  label: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
  url?: string;
  onClick?: () => void;
}

interface SideNavItemProps {
  item: SideNavItemConfig;
  active: boolean;
  collapsed: boolean;
  headerTextColor: string;
  primaryButtonColor: string;
  selectionBackgroundPrimary: string;
  fontFamily: string;
  onSelect: (item: SideNavItemConfig) => void;
}

export function SideNavItem({
  item,
  active,
  collapsed,
  headerTextColor,
  primaryButtonColor,
  selectionBackgroundPrimary,
  fontFamily,
  onSelect,
}: SideNavItemProps): JSX.Element {
  const Icon = item.icon;

  return (
    <div key={item.key} style={{ position: "relative", width: "100%" }}>
      {/* Selection bar */}
      <div
        style={{
          position: "absolute",
          left: collapsed ? "8px" : "12px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: "18px",
          borderRadius: "2px",
          background: active ? primaryButtonColor : "transparent",
        }}
      />
      <button
        onClick={() => onSelect(item)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          width: collapsed ? "calc(100% - 16px)" : "calc(100% - 20px)",
          marginLeft: collapsed ? "8px" : "12px",
          marginRight: collapsed ? "8px" : "8px",
          background: active ? selectionBackgroundPrimary : "transparent",
          border: "none",
          borderRadius: "8px",
          color: headerTextColor,
          cursor: "pointer",
          padding: collapsed ? "11px 0" : "11px 14px",
          justifyContent: collapsed ? "center" : "flex-start",
          fontFamily,
          fontSize: "0.95rem",
          textAlign: "left",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
        onMouseEnter={(e) => {
          if (!active) {
            (e.currentTarget as HTMLButtonElement).style.background =
              selectionBackgroundPrimary;
          }
        }}
        onMouseLeave={(e) => {
          if (!active) {
            (e.currentTarget as HTMLButtonElement).style.background =
              "transparent";
          }
        }}
      >
        <Icon size={18} color={active ? primaryButtonColor : headerTextColor} />
        {!collapsed && <span>{item.label}</span>}
      </button>
    </div>
  );
}
